import type { CriticalDatesType, FetchComp, ModalProps } from '#shared/types/appTypes/globalTypes'
import type { CcustosType } from '#shared/types/dbTypes/appTypes/ccustosTypes'
import type { OpenMonthItemsType, ResourcesFault } from '#shared/types/dbTypes/appTypes/globalsTypes'
import type { RatesType } from '#shared/types/dbTypes/appTypes/ratesTypes'
import type { RhItemType, ActivityType } from '#shared/types/dbTypes/productionTypes'
import type { PagesRights } from '#shared/types/appTypes/globalTypes'
import type { SettingsType } from "#shared/types/dbTypes/settingsTypes"

type PickedCenter = {
  'code': string | null;
  'name': string | null

}



let now = new Date()
const lastYear = new Date(now.setFullYear(now.getFullYear() - 1))
  .toISOString()
  .substring(0, 10)

now = new Date()

const lastHalfYear = new Date(now.setMonth(now.getMonth() - 6))
  .toISOString()
  .substring(0, 10)

now = new Date()

const last3months = new Date(now.setMonth(now.getMonth() - 3))
  .toISOString()
  .substring(0, 10)

now = new Date()

const lastMonth = new Date(now.setMonth(now.getMonth() - 1))
  .toISOString()
  .substring(0, 10)


export const useGlobalStore = defineStore("GlobalStore", () => {
  //State
  const appSettings: Ref<SettingsType | null> = ref(null)
  const cCustos: Ref<CcustosType[] | null> = ref(null)
  const criticalDates: Ref<CriticalDatesType> = ref({
    'lastYear': lastYear,
    'lastHalfYear': lastHalfYear,
    'last3months': last3months,
    'lastMonth': lastMonth
  })
  const fetchComp: Ref<FetchComp> = ref({
    'url': '',
    'from': '',
    'keyNumber': 0,
    'options': {
      'method': 'GET'
    }
  })
  const modal: Ref<ModalProps> = ref({
    'answer': null,
    'from': null,
    'allowClose': true,
    'confirmationQuestion': {
      'question': null,
      'actions': {
        'positive': null,
        'negation': null
      }
    },
    'key': 0,
    'hadActions': false,
    'isActive': false,
    'isMultiline': false,
    'text': [],
    'type': 'error'
  })
  const openMonths: Ref<OpenMonthItemsType[] | null> = ref(null)
  const pagesRights: Ref<PagesRights | null> = ref(null)
  const pickedActivitie: Ref<string> = ref('')
  const professions: Ref<string[] | null> = ref(null)
  const pickedCenter: Ref<PickedCenter> = ref({
    'code': null,
    'name': null
  })
  const resourcesFaults: Ref<ResourcesFault | null> = ref(null)
  const rhArray: Ref<RhItemType[] | null> = ref(null)
  const rhidToCodeArray: Ref<{ [key: string]: string } | null> = ref(null)
  const rates: Ref<RatesType | null> = ref(null)
  const dbActivities: Ref<ActivityType[] | null> = ref(null)



  //Getters

  const faultCodes = computed(() => {
    return resourcesFaults.value!.humanResources.map(hr => hr.code) || []
  })

  const FAULTS = computed(() => {
    return resourcesFaults.value!.humanResources || []
  })

  //Actions
  async function resetGlobalFetch(): Promise<void> {
    fetchComp.value = {
      'url': '',
      'from': '',
      'keyNumber': 0,
      'options': {
        'method': 'GET'
      }
    }
  }

  async function resetGlobalModal(): Promise<void> {
    modal.value = {
      'answer': null,
      'from': null,
      'allowClose': true,
      'confirmationQuestion': {
        'question': null,
        'actions': {
          'positive': null,
          'negation': null
        }
      },
      'hadActions': false,
      'isActive': false,
      'isMultiline': false,
      'text': [],
      'type': 'error',
      'key': 0
    }
  }

  async function resetGlobalPartial(): Promise<void> {
    fetchComp.value = {
      'url': '',
      'from': '',
      'keyNumber': 0,
      'options': {
        'method': 'GET'
      }
    }
    modal.value = {
      'answer': null,
      'from': null,
      'allowClose': true,
      'confirmationQuestion': {
        'question': null,
        'actions': {
          'positive': null,
          'negation': null
        }
      },
      'hadActions': false,
      'isActive': false,
      'isMultiline': false,
      'text': [],
      'type': 'error',
      'key': 0
    }
  }

  return {
    appSettings,
    cCustos,
    criticalDates,
    dbActivities,
    faultCodes,
    FAULTS,
    fetchComp,
    modal,
    openMonths,
    pagesRights,
    pickedActivitie,
    professions,
    pickedCenter,
    resourcesFaults,
    rhArray,
    rhidToCodeArray,
    rates,
    resetGlobalFetch,
    resetGlobalModal,
    resetGlobalPartial
  }
})